import { CollideEvent, CollideId } from '../../defs/collide';
import type { ParcelsBlockEntity } from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { InvalidEffect } from '../effects/InvalidEffect';
import { ParcelsEffect } from '../effects/ParcelsEffect';
import { CollideHandler, ICollision } from './ICollision';

/*
  parcels block collision resolver
*/
export class ParcelsCollision implements ICollision {
  private readonly scene: GameScene;
  private readonly entity: ParcelsBlockEntity;
  private readonly resolvers: { [key in CollideId]?: CollideHandler } = {
    attack: this.resolveTrigger,
    block: this.resolveTrigger,
    tap: this.resolveTap,
  };

  constructor(scene: GameScene, entity: ParcelsBlockEntity) {
    this.scene = scene;
    this.entity = entity;
  }

  public async resolve(event: CollideEvent): Promise<boolean> {
    return this.resolvers[event.id]?.call(this, event) ?? false;
  }

  private async resolveTap() {
    await new InvalidEffect(this.entity).execute();
    return false;
  }

  private async resolveTrigger() {
    await this.spawn();
    return true;
  }

  private async spawn() {
    await new ParcelsEffect(this.scene, {
      subject: this.entity,
    }).execute();
  }
}
